import React from 'react';
import { AlertDialog, AlertDialogButton } from 'react-onsenui';
import PropTypes from 'prop-types';

const InformationModal = props => (
    <AlertDialog isOpen={props.show} onCancel={props.onCancel}>
        <div className="alert-dialog-title" style={{textAlign: 'center', marginBottom: '10px'}}>
            <h6 style={{marginBottom: 0, color: '#004586', fontWeight: '700', fontFamily: 'fff-equipe'}}>{props.title || 'Information'}</h6>
        </div>
        <div className="alert-dialog-content" style={{fontSize: '14px', textAlign: 'center', marginTop: 0, color: '#004586', fontFamily: 'fff-equipe'}}>
            {props.content}
        </div>
        <div className="alert-dialog-footer">
            <AlertDialogButton onClick={props.onCancel}>
                <span style={{fontWeight: '700', textAlign: 'center', color: '#004586', fontFamily: 'fff-equipe'}}>Ok</span>
            </AlertDialogButton>
        </div>
    </AlertDialog>
);

InformationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    title: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired
}

export default InformationModal;